import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { setCartConfig } from '../actions/set-cart-config.actions';
import { Router } from '@angular/router';
import { noAction } from '@shared/actions/no-action.actions';
import { switchMap, withLatestFrom } from 'rxjs';
import { createCart } from '../actions/create-cart.actions';
import { loadGroup } from '@shared/actions/load-group.actions';
import { CartsService } from '../services/carts.service';

@Injectable()
export class SetCartConfigEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private cartsService: CartsService,
  ) {}

  setCartConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setCartConfig),
      withLatestFrom(this.cartsService.getCartCustomer()),
      switchMap(([action, customer]) => {
        if (
          ['new', 'nfr', 'trial', 'pricing'].includes(action.cartConfig.quote_type!) &&
          !(action.cartConfig.order_id || action.cartConfig.itemable_id)
        ) {
          this.router.navigate(['cart/review']);
          if (action.cartConfig.opportunity_id && action.cartConfig.group_id && action.cartConfig.offering_code) {
            if (!customer || customer?.id !== action.cartConfig.group_id) {
              return [createCart({ cartConfig: action.cartConfig, loadCartConfigGroup: true })];
            }
            return [createCart({ cartConfig: action.cartConfig })];
          }
          if (action.cartConfig.group_id && (!customer || customer?.id !== action.cartConfig.group_id)) {
            return [loadGroup({ groupId: action.cartConfig.group_id! })];
          }
        }

        if (
          ['trial', 'nfr', 'enlarge', 'renew', 'extend', 'convert'].includes(action.cartConfig.quote_type!) &&
          (action.cartConfig.order_id || action.cartConfig.itemable_id || action.cartConfig.opportunity_id)
        ) {
          this.router.navigateByUrl('/cart/review');
          if (!customer || customer?.id !== action.cartConfig.group_id) {
            return [createCart({ cartConfig: action.cartConfig, loadCartConfigGroup: true })];
          }
          return [createCart({ cartConfig: action.cartConfig })];
        }

        return [noAction()];
      }),
    ),
  );
}
